import PropTypes from 'prop-types'
import classNames from 'classnames'
import copy from 'copy-to-clipboard'
import dynamic from 'next/dynamic'

import Typography from '../typography'

const BaseCopyToClipboard = ({ size = 32, url, light, ...attrs }) => {
  let fullUrl = url

  if (typeof window !== 'undefined') {
    fullUrl = window.location.origin + fullUrl
  }

  const handleShare = () => {
    copy(fullUrl)
  }

  attrs.className = classNames(
    attrs.className,
    [
      'cursor-pointer'
    ]
  )

  return <div
    {...attrs}
    onClick={handleShare}>
    <Typography
      size={'two'}
      className={'mb-1 text-gray-400'}>
      Haz clic para copiar el vínculo
    </Typography>
    <Typography
      className={'border-b border-gray-300 text-gray-500'}>
      {fullUrl}
    </Typography>
  </div>
}

BaseCopyToClipboard.propTypes = {
  light: PropTypes.bool,
  size: PropTypes.number,
  url: PropTypes.string
}

const CopyToClipboard = dynamic(() => Promise.resolve(BaseCopyToClipboard), {
  ssr: false
})

export default CopyToClipboard
